import { render } from "./Login.vue?vue&type=template&id=387de786"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=387de786&lang=css"
script.render = render

export default script